import { useState } from 'react';
import { Tabs } from '@fiado/react-kit';
import { useAuth } from '../../hooks/useAuth';
import { RolesTable } from './RolesTable';
import { TenantPermissionMatrix } from './TenantPermissionMatrix';

type RolesTab = 'roles' | 'matrix';

const TABS: { key: RolesTab; label: string }[] = [
    { key: 'roles', label: 'Roles' },
    { key: 'matrix', label: 'Matriz de permisos' },
];

/** Pantalla de roles del tenant; la matriz solo la ve un actor del propio tenant. */
export function TenantRolesTabs() {
    const { user, isPlatform } = useAuth();
    const [tab, setTab] = useState<RolesTab>('roles');
    const showMatrix = !isPlatform && !!user?.tenantId;

    if (!showMatrix) return <RolesTable />;

    return (
        <div className="space-y-4">
            <Tabs
                tabs={TABS}
                activeTab={tab}
                onChange={(k) => {
                    setTab(k as RolesTab);
                }}
            />
            {tab === 'roles' ? <RolesTable /> : <TenantPermissionMatrix />}
        </div>
    );
}
